import classNames from 'classnames'
import * as React from 'react'

interface ChartBoxProps extends Omit<React.HTMLProps<HTMLDivElement>, 'label'> {
  label?: React.ReactNode
}

export function ChartBox({ label, children, ...props }: React.PropsWithChildren<ChartBoxProps>) {
  return (
    <div
      {...props}
      className={classNames(props.className, 'border border-primary p-1 tabular-nums', {
        'rounded-md': FinvizSettings.hasRedesignEnabled,
      })}
    >
      <div className="flex h-10 items-center">
        <span className="ml-2 mt-4 h-10 text-sm text-muted font-medium">{label}</span>
      </div>
      {children}
    </div>
  )
}
